import React from 'react';
import { useCenturionStore } from '../lib/store';
import { getDaysBetween, getLocalDateString } from '../lib/game-logic';
import { motion } from 'framer-motion';
import { Check, X, Circle } from 'lucide-react';
export function CalendarGrid() {
  const {
    profile,
    isLoaded
  } = useCenturionStore();
  if (!isLoaded || !profile) return null;
  const days = Array.from({
    length: 100
  }, (_, i) => i + 1);
  const todayStr = getLocalDateString(new Date(), profile.timezone);
  const currentDayNumber = getDaysBetween(profile.startDate, todayStr) + 1;
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="max-w-4xl mx-auto pb-24" data-id="element-95">
      <header className="mb-8" data-id="element-96">
        <h1 className="text-3xl font-bold tracking-tight text-gray-100 mb-2" data-id="element-97">
          Century Grid
        </h1>
        <p className="text-gray-400" data-id="element-98">Your 100-day journey visualized.</p>
      </header>

      <div className="bg-surface-300 rounded-xl p-1 border border-surface-100 shadow-2xl" data-id="element-99">
        <div className="bg-surface-400 rounded-lg p-4 sm:p-8" data-id="element-100">
          <div className="grid grid-cols-5 sm:grid-cols-10 gap-2 sm:gap-3" data-id="element-101">
            {days.map(dayNum => {
            // Calculate the date for this day number
            const date = new Date(`${profile.startDate}T00:00:00Z`);
            date.setDate(date.getDate() + (dayNum - 1));
            const dateStr = getLocalDateString(date, profile.timezone);
            const log = profile.logs[dateStr];
            const isPast = dayNum < currentDayNumber;
            const isToday = dayNum === currentDayNumber;
            const isFuture = dayNum > currentDayNumber;
            let statusColor = 'bg-surface-200 border-surface-100 text-gray-600';
            let Icon = Circle;
            if (isToday) {
              statusColor = 'bg-centurion-900/20 border-centurion-500 text-centurion-500 ring-2 ring-centurion-500/50';
              Icon = Circle;
            } else if (isPast) {
              if (log?.finalized) {
                statusColor = 'bg-emerald-900/20 border-emerald-500 text-emerald-500';
                Icon = Check;
              } else {
                // This shouldn't happen normally due to reset mechanic, but just in case
                statusColor = 'bg-red-900/20 border-red-500 text-red-500';
                Icon = X;
              }
            } else if (isFuture) {
              statusColor = 'bg-surface-200 border-surface-100 text-surface-100 opacity-50';
              Icon = Circle;
            }
            return <motion.div key={dayNum} whileHover={!isFuture ? {
              scale: 1.1,
              zIndex: 10
            } : {}} className={`relative aspect-square flex flex-col items-center justify-center rounded-md border ${statusColor} transition-colors group cursor-default`} title={dateStr} data-id="element-102">
                  <span className="text-xs font-mono-num font-semibold mb-1 absolute top-1 left-1 opacity-50 group-hover:opacity-100 transition-opacity" data-id="element-103">
                    {dayNum}
                  </span>
                  <Icon size={16} className={isFuture ? 'opacity-0' : 'opacity-100'} data-id="element-104" />

                  {/* Tooltip */}
                  {!isFuture && <div className="absolute bottom-full mb-2 hidden group-hover:block w-max bg-surface-500 text-xs text-gray-200 px-2 py-1 rounded shadow-xl border border-surface-100 z-20" data-id="element-105">
                      {dateStr}
                    </div>}
                </motion.div>;
          })}
          </div>

          <div className="mt-8 flex items-center justify-center gap-6 text-sm text-gray-400" data-id="element-106">
            <div className="flex items-center gap-2" data-id="element-107">
              <div className="w-3 h-3 rounded-sm bg-emerald-900/20 border border-emerald-500" data-id="element-108"></div>{' '}
              Completed
            </div>
            <div className="flex items-center gap-2" data-id="element-109">
              <div className="w-3 h-3 rounded-sm bg-centurion-900/20 border border-centurion-500" data-id="element-110"></div>{' '}
              Today
            </div>
            <div className="flex items-center gap-2" data-id="element-111">
              <div className="w-3 h-3 rounded-sm bg-surface-200 border border-surface-100" data-id="element-112"></div>{' '}
              Future
            </div>
          </div>
        </div>
      </div>
    </motion.div>;
}